(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/store/redux.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/store/redux.js');
"use strict";

var _svs$arena$data, _svs$arena$data2, _teamsPreloaded$teams;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _svs$arena$store$team = svs.arena.store.teams,
  myTeamsReducer = _svs$arena$store$team.reducer,
  teamsInitialState = _svs$arena$store$team.initialState;
const _svs$arena$store$tran = svs.arena.store.transactions,
  myTransactionsReducer = _svs$arena$store$tran.reducer,
  transactionsInitialState = _svs$arena$store$tran.initialState;
const _svs$arena$store$wage = svs.arena.store.wagers,
  myWagersReducer = _svs$arena$store$wage.reducer,
  wagesInitialState = _svs$arena$store$wage.initialState;
const _svs$arena$store$game = svs.arena.store.gameguide,
  myGameGuideReducer = _svs$arena$store$game.reducer,
  gameGuideInitialState = _svs$arena$store$game.initialState;
const reducerObject = {
  teams: myTeamsReducer,
  transactions: myTransactionsReducer,
  wagers: myWagersReducer,
  gameguide: myGameGuideReducer
};

svs.arena.store.createStore = function () {
  let preloaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return RTK.configureStore({
    reducer: reducerObject,
    preloadedState: preloaded
  });
};

const teamsPreloaded = ((_svs$arena$data = svs.arena.data) === null || _svs$arena$data === void 0 || (_svs$arena$data = _svs$arena$data.preloadedState) === null || _svs$arena$data === void 0 ? void 0 : _svs$arena$data.teams) || {
  teams: []
};
const transactionsPreloaded = ((_svs$arena$data2 = svs.arena.data) === null || _svs$arena$data2 === void 0 || (_svs$arena$data2 = _svs$arena$data2.preloadedState) === null || _svs$arena$data2 === void 0 ? void 0 : _svs$arena$data2.transactions) || {
  transactions: []
};
const addDatesToPreloadedPropertyObjects = inputObject => {
  const newObject = {};
  for (const property in inputObject) {
    if (Object.prototype.hasOwnProperty.call(inputObject, property)) {
      newObject[property] = _objectSpread(_objectSpread({}, inputObject[property]), {}, {
        latestFetch: new Date().getTime()
      });
    }
  }
  return newObject;
};

const totalTeams = {
  teams: [...teamsInitialState.teams, ...teamsPreloaded.teams],
  teamDetails: [...teamsInitialState.teamDetails],
  inviteIds: [...teamsInitialState.inviteIds],
  latestFetch: (_teamsPreloaded$teams = teamsPreloaded.teams) !== null && _teamsPreloaded$teams !== void 0 && _teamsPreloaded$teams.length ? new Date().getTime() : 0,
  error: teamsPreloaded.error
};

const totalTransactions = _objectSpread(_objectSpread({}, transactionsInitialState.transactions), addDatesToPreloadedPropertyObjects(transactionsPreloaded.transactions || {}));

const store = svs.arena.store.createStore({
  teams: totalTeams,
  transactions: totalTransactions,
  wagers: wagesInitialState,
  gameguide: gameGuideInitialState
});
const ArenaReduxProvider = _ref => {
  let children = _ref.children;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.arena.store.ArenaReduxProvider = ArenaReduxProvider;

 })(window);